export default __webpack_public_path__ + "static/media/platinum-grey.26b9b26b.jpg";